import moment from 'moment';
import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ListWidgetComponentFactory } from '~/components/MyWorkspace/ListWidget';
import { TabModules, useModulesConfig } from '~/data/company';
import { PeopleTabs } from '~/data/tabs';
import { People } from '~/services/Http';
import { useGetTeamAbsences } from '~/services/Http/hooks';

import { WidgetProps, getWidgetDataRequestRoles } from '../../data/widgets';

import { Absence } from './components/Absence';
import { AbsenceInfo } from './components/AbsenceInfo';

export interface Props extends WidgetProps {}

const TeamAbsencesTodayWidgetComponent = ListWidgetComponentFactory({
  ListItemComponent: Absence,
  getIdentifier: (item: People.AbsenceDto) => item.id,
  ListItemInfoComponent: AbsenceInfo,
  dataCy: 'team-absences-today-widget',
});

export const TeamAbsencesTodayWidget: React.FC<Props> = ({ title, config }) => {
  const { t } = useTranslation();

  const dataRequestRoles = useMemo(() => {
    return getWidgetDataRequestRoles(config?.role);
  }, [config]);

  const getTeamAbsencesReqParams = {
    employeeId: 'me',
    startDate: moment().startOf('day').utc(true).toDate(),
    endDate: moment().endOf('day').utc(true).toDate(),
    roles: dataRequestRoles,
  };
  const {
    data: absences,
    loading,
    failedToLoad,
  } = useGetTeamAbsences(getTeamAbsencesReqParams);

  const { isModuleTabEnabled } = useModulesConfig();

  return (
    <TeamAbsencesTodayWidgetComponent
      title={title || t('teamAbsencesToday')}
      noDataMessage={t('noAbsencesToday')}
      data={absences}
      loading={loading}
      failedToLoad={failedToLoad}
      isTabDisabled={
        !isModuleTabEnabled(TabModules.PEOPLE, PeopleTabs.Absences)
      }
    />
  );
};
